import BellStrikethroughIconPath from "@ingka/ssr-icon/paths/bell-strikethrough";

export default BellStrikethroughIconPath;
